import { Injectable, Signal } from '@angular/core';
import { StateAccessService } from '../../../services';

import { IAccountData, ICustomer, ILoginData, ILoginModel } from '@partners/api';
import { Observable } from 'rxjs';
import { AuthActions, AuthSelectors, IAuthLoginState } from '../store';

@Injectable({
  providedIn: 'root'
})
export class AuthLoginStore extends StateAccessService<IAuthLoginState> {
  state$: Observable<IAuthLoginState<ILoginModel, ILoginData>>;

  readonly model$$: Signal<ILoginModel>;
  readonly data$$: Signal<ILoginData>;

  readonly isLoggedIn$$: Signal<boolean>;
  readonly customerData$$: Signal<ICustomer>;
  readonly accountData$$: Signal<IAccountData>;

  constructor() {
    super();

    this.model$$ = this.stateFacade.selectSignal$(AuthSelectors.loginModel);
    this.data$$ = this.stateFacade.selectSignal$(AuthSelectors.loginData);
    this.isLoggedIn$$ = super.stateFacade.selectSignal$(AuthSelectors.isLoggedIn);
    this.customerData$$ = super.stateFacade.selectSignal$(AuthSelectors.customerLoginData);
    this.accountData$$ = super.stateFacade.selectSignal$(AuthSelectors.accountLoginData);
  }

  dispatchLoginReset() {
    this.stateFacade.dispatch(AuthActions.resetLogin());
  }

  /**
   * auth login dispatches
   */
  dispatchLoginLoad() {
    this.stateFacade.dispatch(AuthActions.loadLogin());
  }
  dispatchLoginLoadSuccess({ model, data }: { model: ILoginModel; data: ILoginData }) {
    this.stateFacade.dispatch(AuthActions.loadLoginSuccess({ model, data }));
  }
  dispatchLoginLoadFailure(error: any) {
    this.stateFacade.dispatch(AuthActions.loadLoginFailure(error));
  }
  dispatchLoginSubmit({ model }: { model: ILoginModel }) {
    this.stateFacade.dispatch(AuthActions.submitLogin({ model }));
  }
  dispatchLoginSubmitSuccess({ data }: { data: ILoginData }) {
    this.stateFacade.dispatch(AuthActions.submitLoginSuccess({ data }));
  }
  dispatchLoginSubmitFailure(error: any) {
    this.stateFacade.dispatch(AuthActions.submitLoginFailure(error));
  }
}
